import { Component, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { ToastComponent } from '../../shared/toast/toast.component';
import { PoliticianService } from '../../services/politician.service';
import { setClassInvalid } from '../../shared/functions';
import { ee, usernameRegexp } from '../../shared/constants';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-add-media-form',
  templateUrl: './add-media-form.component.html',
  standalone: false
})
export class AddMediaFormComponent {
  private politicianService = inject(PoliticianService);
  private formBuilder = inject(UntypedFormBuilder);
  toast = inject(ToastComponent);


  addMediaForm = this.createMediaForm();
  usernameRegexp = usernameRegexp;
  setClassInvalid = setClassInvalid;

  createMediaForm(): UntypedFormGroup {
    return this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', Validators.email],
      phone: [''],
      live: [''],
      notes: [''],
      socials: this.formBuilder.group({
        twitter: this.formBuilder.group({
          username: ['', Validators.pattern(usernameRegexp.twitter)]
        }),
        instagram: this.formBuilder.group({
          username: ['', Validators.pattern(usernameRegexp.instagram)]
        }),
        facebook: this.formBuilder.group({
          username: ['', Validators.pattern(usernameRegexp.facebook)]
        }),
        linkedin: this.formBuilder.group({
          username: ['', Validators.pattern(usernameRegexp.linkedin)]
        })
      })
    });
  }

  formatUsername(social: string): void {
    const username = this.addMediaForm.get(`socials.${social}.username`).value;
    this.addMediaForm.patchValue({
      socials: {
        [social]: {
          username: (username || '').trim().replace(/\s+|@/g, '')
        }
      }
    });
  }

  addMedia(): void {
    this.politicianService.addMedia(this.addMediaForm.value)
      .pipe(finalize(() => {
        ee.emit('getMedias');
        ee.emit('mediaAdded', true);
      }))
      .subscribe({
        next: res => this.toast.setMessage('Media added successfully!', 'success'),
        error: err => this.toast.setMessage(err.error.message, 'danger')
      });
  }

}
